<template>
    <!-- Button trigger modal -->
    <!--        <button type="button" class="btn btn-primary" data-toggle="modal" data-target="#exampleModal">
                Launch demo modal
            </button>-->

    <!-- Modal -->
    <!-- .. id="exampleModal" aria-labelledby="exampleModalLabel" ..  [ aria-modal="true" || aria-hidden="true" ] .. -->
    <div :class="{'modal fade': true, 'show d-block': visible}" tabindex="-1" role="dialog" data-backdrop="true" data-show="show">
        <div class="modal-dialog modal-dialog-centered__ modal-lg__ modal-xl" role="document"> <!-- .. .modal-dialog-scrollable .. -->
            <div class="modal-content">
                <div class="modal-header" v-if="title">
                    <h5 class="modal-title" id="exampleModalLabel" v-html="title"></h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>

                <div class="modal-body">
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close" @click="close" v-if="!title">
                        <span aria-hidden="true">&times;</span>
                    </button>

                    <slot></slot>
                </div>
                <!--                    <div class="modal-footer" >
                                        <button type="button" class="btn btn-secondary" data-dismiss="modal" @click="close">Закрити</button>
                                        <button type="button" class="btn btn-primary">Save changes</button>
                                    </div>-->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'modal',
    props: {
        title: { type: [String], default: '', required: false },
    },
    data() {
        return {
            visible: true,
        }
    },
    methods: {
        close() {
            this.visible = false;
            this.$emit('close', {});
        }
    }
}
</script>

<style scoped>

</style>
